import type { Metric } from '../types/executive'

export const metrics: Metric[] = [
  {
    value: '$850M+',
    label: 'Capital & Contract Awards Secured',
    detail: 'Cumulative institutional, healthcare, aviation, and civic programs',
  },
  {
    value: '35+ Years',
    label: 'Construction Management Leadership',
    detail: 'Including 15+ years of multi-state regional executive oversight',
  },
  {
    value: 'P&L Turnaround',
    label: 'From Deficit to Sustained Profitability',
    detail: 'Significant multi-million-dollar earnings improvement',
  },
  {
    value: '$585M',
    label: 'Aviation Portfolio Delivered',
    detail: '$460M LAX terminal cores completed with zero critical claims',
  },
]
